import { Box, useTheme } from '@mui/material';

export default function SvgLoadingAnimation({
  width = 24,
  height = 24,
  color
}: {
  width?: number;
  height?: number;
  color?: string;
}) {
  const theme = useTheme();
  const strokeColor = color ?? theme.palette.brand;
  // The path is derived from the Lottie file's bezier curve data
  // Original viewBox was much larger, normalized to 61x61 (the path bounds)
  const pathD = `
    M19.58 41.82
    C19.58 37.488 19.58 33.152 19.58 28.82
    C19.58 22.209 25.01 16.51 31.71 16.51
    C38.41 16.51 43.32 23.6 43.32 30.21
    C43.32 31.625 43.32 33.035 43.32 34.45
    C43.32 39.283 46.377 43.2 51.21 43.2
    C55.227 43.2 58.931 40.499 59.64 36.81
    C59.851 35.374 59.96 33.905 59.96 32.41
    C59.96 31.089 59.96 29.765 59.96 28.44
    C59.96 13.496 47.844 0 32.9 0
    C31.926 0 30.954 0 29.98 0
    C13.422 0 0 13.44 0 29.98
    C0 30.327 0 30.673 0 31.02
    C0 47.578 13.44 61 29.98 61
    C37.22 61 43.859 58.433 49.04 54.16
  `.trim();

  // Calculate the approximate path length for stroke-dasharray
  const pathLength = 252;

  return (
    <Box
      component="svg"
      sx={{
        width: width,
        height: height,
        overflow: 'visible',
        color: strokeColor,
        '& .natoma-loading-path': {
          strokeDasharray: pathLength,
          strokeDashoffset: pathLength,
          animation: 'natomaDrawErase 2s ease-in-out infinite'
        },
        '@keyframes natomaDrawErase': {
          '0%': {
            strokeDashoffset: pathLength
          },
          '10%': {
            strokeDashoffset: pathLength
          },
          '50%': {
            strokeDashoffset: 0
          },
          '60%': {
            strokeDashoffset: 0
          },
          '100%': {
            strokeDashoffset: -pathLength
          }
        }
      }}
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="natoma-loading-path"
        d={pathD}
        stroke="currentColor"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Box>
  );
}
